exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".theme-tabs,.theme-tabs .tab-body{flex:1;display:flex;flex-flow:column}.theme-tabs .tab-body{height:0}.theme-tabs .tab-heads{height:30px;display:flex;flex-flow:row;flex-shrink:0;margin:5px;list-style:none;padding:0}.theme-tabs .tab-heads .tab-label{height:30px;padding:0 20px;display:flex;align-items:center;margin-right:5px;cursor:pointer}.theme-tabs .tab-heads .tab-label:hover{background:#f5f5f5;color:#000}.theme-tabs .tab-heads .tab-label.active{border-radius:3px;background:#75b325;color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8eb87966","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/shell/components/tabs/ThemeTabs.vue
// module id = 255
// module chunks = 0